import React from 'react';
import { Icon } from '@iconify/react';

interface CashflowAddActionBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectManualTx: () => void;
  onSelectAddAccount: () => void;
  onSelectExportReport?: () => void;
}

export const CashflowAddActionBottomSheet: React.FC<CashflowAddActionBottomSheetProps> = ({
  isOpen,
  onClose,
  onSelectManualTx,
  onSelectAddAccount,
  onSelectExportReport,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-xs transition-opacity"
        onClick={onClose}
      />

      {/* Sheet Content */}
      <div className="relative w-full max-w-md bg-white rounded-t-3xl sm:rounded-3xl p-5 shadow-2xl z-10 space-y-4 animate-in slide-in-from-bottom duration-200">
        <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto sm:hidden" />

        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base font-extrabold text-[#0E1726]">Kelola Kas Komunitas</h3>
            <p className="text-xs text-gray-400 font-medium">Pilih jenis aksi yang ingin kamu lakukan</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
          >
            <Icon icon="ph:x-bold" className="w-4 h-4" />
          </button>
        </div>

        <div className="space-y-2.5 pt-1">
          {/* Option 1: Catat Transaksi Manual */}
          <button
            type="button"
            onClick={() => {
              onClose();
              onSelectManualTx();
            }}
            className="w-full p-4 rounded-2xl border border-[#E0E6ED] bg-gray-50/50 hover:bg-gray-50 transition-all flex items-center justify-between text-left group cursor-pointer active:scale-[0.99]"
          >
            <div className="flex items-center gap-3.5 min-w-0">
              <div className="w-11 h-11 rounded-2xl bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">
                <Icon icon="ph:pencil-line-bold" className="w-5 h-5" />
              </div>
              <div className="min-w-0">
                <h4 className="text-sm font-bold text-[#0E1726]">Catat Transaksi Manual</h4>
                <p className="text-xs text-gray-400 font-medium truncate mt-0.5">
                  Pemasukan & pengeluaran di luar event
                </p>
              </div>
            </div>
            <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-gray-300 group-hover:text-gray-500 transition-colors shrink-0" />
          </button>

          {/* Option 2: Tambah Kantong Dana */}
          <button
            type="button"
            onClick={() => {
              onClose();
              onSelectAddAccount();
            }}
            className="w-full p-4 rounded-2xl border border-[#E0E6ED] bg-gray-50/50 hover:bg-gray-50 transition-all flex items-center justify-between text-left group cursor-pointer active:scale-[0.99]"
          >
            <div className="flex items-center gap-3.5 min-w-0">
              <div className="w-11 h-11 rounded-2xl bg-orange-50 text-[#FC480D] flex items-center justify-center shrink-0">
                <Icon icon="ph:wallet-bold" className="w-5 h-5" />
              </div>
              <div className="min-w-0">
                <h4 className="text-sm font-bold text-[#0E1726]">Tambah Kantong Kas</h4>
                <p className="text-xs text-gray-400 font-medium truncate mt-0.5">
                  Rekening bank, kas tunai, atau e-wallet
                </p>
              </div>
            </div>
            <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-gray-300 group-hover:text-gray-500 transition-colors shrink-0" />
          </button>

          {/* Option 3: Export Laporan Kas */}
          {onSelectExportReport && (
            <button
              type="button"
              onClick={() => {
                onClose();
                onSelectExportReport();
              }}
              className="w-full p-4 rounded-2xl border border-[#E0E6ED] bg-gray-50/50 hover:bg-gray-50 transition-all flex items-center justify-between text-left group cursor-pointer active:scale-[0.99]"
            >
              <div className="flex items-center gap-3.5 min-w-0">
                <div className="w-11 h-11 rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
                  <Icon icon="ph:chart-bar-bold" className="w-5 h-5" />
                </div>
                <div className="min-w-0">
                  <h4 className="text-sm font-bold text-[#0E1726]">Export & Rekap Tahunan</h4>
                  <p className="text-xs text-gray-400 font-medium truncate mt-0.5">
                    Download rincian kas lengkap dalam Excel
                  </p>
                </div>
              </div>
              <Icon icon="ph:caret-right-bold" className="w-4 h-4 text-gray-300 group-hover:text-gray-500 transition-colors shrink-0" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
